export default "__VITE_ASSET__BcBfHvHe__"